import axios from "axios";
import { GET_CHANNEL_PARTNER } from "../redux/User/types";


export const BaseUrl = "https://cp.knsconnect.in/";
export const ErpBaseUrl = "https://knsonline.in/RestAPI_V1/cp";
export const DocumentUrl = "https://knsonline.in/";


// export const BaseUrl = "https://knsonline.in/RestAPI_V1/";
// export const ErpBaseUrl = "http://192.168.0.200/RestAPI_V1/";
// export const DocumentUrl = "https://knsonline.in/";




// export const BaseUrl = 'https://knsonline.in/RestAPI/customer/';
// export const DocumentUrl = 'https://knsonline.in/';

// export const ErpBaseUrl = "https://192.168.0.200/dev/RestAPI_V1/cp";
// export const BaseUrl = "https://knsonline.in/dev/RestAPI_V1/cp";
// export const DocumentUrl = "https://knsonline.in/dev/";


// export const ErpBaseUrl = "https://knsonline.in/uat/RestAPI_V1/cp";
// export const BaseUrl = "https://knsonline.in/uat/RestAPI_V1/cp";
// export const DocumentUrl = "https://knsonline.in/uat/";


// export const ErpBaseUrl = "https://knsonline.in/dev/RestAPI_V1/cp";
// export const BaseUrl = "https://knsonline.in/dev/RestAPI_V1/cp";
// export const DocumentUrl = "https://knsonline.in/dev/";

// export const BaseUrl = "http://192.168.0.201/dev/RestAPI_V1/cp";
// export const DocumentUrl = "https://192.168.0.201/dev/";



export const ApiPaths = {
    BD_USER: "/getUser",

  LOGIN: "cpLogin",
  OTPVERIFY: "verifyCpOtp",
  GET_SITES: "getMySites",
  GET_MySITEDETAILS: "getMySiteDetail",
  GET_PROJECTS: "getWebProject",
  GET_NOTIFICATIONS: "getMyNotification",
  GET_MySITEPAYMEMTS: "getSitePayment",
  GET_MySITEDOCUMENTS: "getMyDocuments",
  GET_SITEPROGRESS: "getProjectProgressMilstone",
  GET_SITEPROGRESS_IMAGE: "getProjectProgressImages",
  GET_FEEDBACK: "getMyFeedback",
  POST_FEEDBACK: "addCustomerFeedback",
  GET_CONTACTS: "getCustomerContacts",
  GET_QUERIES: "getMyQuery",
  POST_QUERY: "addCustomerQuery",

  GET_TICKETS_FALLOWUP: "getTicketFollowUp",
  POST_FALLOWUP: "addTicketFollowUp",
  GET_NEWS: "GetNews",
  GET_TESTS: "GetTests",
  GET_QUESTIONS: "GetQuestions/",
  SUBMIT_RESULT: "SubmitTestResult",
  GET_TEST_RESULT: "GetResult/",
  UPDATE_PROFILE: "ProfileUpdate",
  UPLOAD_PROFILE_PIC: "UploadProfilePic",
  CHANGE_PASSWORD: "UpdatePassword",
  GET_ORDERS: "GetUserOrders",
  GET_CART_DETAILS: "GetUserCartDetails",
  GET_CART_STATUS: "GetCartStatus",
  ADD_TO_CART: "AddToCart",
  REMOVE_FROM_CART: "RemoveItemFromCart",
  SAVE_CHECKOUT: "SaveCheckout",
  PAYMENT_SUCCESS: "PaymentSuccess",
  //channel partner
  GET_CONSTITUTION_OF_FIRM: "getConstitutionOfFirm",
  CREATE_VENDOR: "registerChannelPartner",
  GET_CHANNEL_PARTNER:"getChannelPartner",
  ADD_CHANNEL_PARTNER:"addChannelPartner",
  GET_PROJECTS:"getProjects",
  CREATE_CP_LEAD:"createCpLead",
  GET_CP_LEAD:"getCpLead",
  GET_CP_DASHBOARD:"getCpDashboard",
  GET_CP_LEAD_SITE_VISIT:"getCpLeadSiteVisit",
  GET_CP_LEAD_DETAIL:"getCpLeadDetail",
  GET_CALL_STATUS:"getCallStatus",
  GET_COUNTRY_CODE:"getCountryCode"

};

export const ApiService = axios.create({
  baseURL: ErpBaseUrl + "/v1/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

export const SetAuthToken = (token) => {
  if (token) {
    ApiService.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete ApiService.defaults.headers.common["Authorization"];
  }
};

export const ApiStatus = {
  OTP_SENT: "OTP sent"
};
